import { useState } from "react";
import { Search } from "lucide-react";

export default function WordSearchSection({ words, t }) {
  const [foundWords, setFoundWords] = useState([]);

  const toggleWord = (word) => {
    setFoundWords(prev => 
      prev.includes(word) 
        ? prev.filter(w => w !== word)
        : [...prev, word]
    );
  };

  const allFound = foundWords.length === words.length;

  return (
    <div className="bg-white rounded-3xl shadow-lg mb-5 overflow-hidden">
      <div className="p-4 border-b" style={{ background: "linear-gradient(90deg, #06D6A0, #118AB2)" }}>
        <div className="flex items-center gap-2">
          <Search size={20} color="white" strokeWidth={2.5} />
          <h3 className="font-black text-white" style={{ fontFamily: "Fredoka, sans-serif" }}>
            {t?.('word_hunt') || 'Word Hunt!'}
          </h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-gray-600 text-sm mb-3">
          {t?.('word_hunt_desc') || "These words are from today's lesson. Check them off as you find them in the story!"}
        </p>
        <div className="flex flex-wrap gap-2">
          {words.map((word, i) => (
            <button
              key={i}
              onClick={() => toggleWord(word)}
              className={`px-3 py-2 rounded-xl font-bold text-sm transition-all ${
                foundWords.includes(word)
                  ? 'bg-green-100 text-green-700 line-through'
                  : 'bg-gray-100 text-gray-700 hover:bg-blue-50'
              }`}
              data-testid={`word-${i}`}
            >
              {foundWords.includes(word) ? '✓ ' : ''}{word}
            </button>
          ))}
        </div>
        {allFound && (
          <div className="mt-4 bg-green-100 rounded-xl p-3 text-center">
            <p className="font-black text-green-700" style={{ fontFamily: "Fredoka, sans-serif" }}>
              {t?.('all_words_found') || 'You found all the words! Great job!'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
